import { render, staticRenderFns } from "./DefaultMenu.vue?vue&type=template&id=3fe8cd00&scoped=true&"
import script from "./DefaultMenu.vue?vue&type=script&lang=js&"
export * from "./DefaultMenu.vue?vue&type=script&lang=js&"
import style0 from "./DefaultMenu.vue?vue&type=style&index=0&id=3fe8cd00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe8cd00",
  null
  
)

export default component.exports